import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import { cloudChiprApi } from "../../../services/cloudchipr.api";
import { RootState } from "../../store";
import { currentBudgetSelector } from "@/store/budgets/selectors/current-budget/currentBudgetSelector";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { formatThresholds } from "@/components/pages/budgets-and-alerts/components/drawer/budget-alert-create-edit-drawer/components/budgets/components/create-budget/utils/helpers/formatThresholds";

export const createBudgetBasedOnFiltersFromCurrentThunk = createAsyncThunk(
  "budgets/createBudgetBasedOnFiltersFromCurrent",
  async (_: void, { dispatch, getState }) => {
    const state = getState() as RootState;

    const { postUsersMeOrganisationsCurrentBudgets } = cloudChiprApi.endpoints;

    const currentBudget = currentBudgetSelector(state);

    if (!currentBudget) {
      return;
    }

    const endDate =
      currentBudget.body.period === "custom" && currentBudget.no_end_date
        ? null
        : currentBudget.body.end_date;
    const amount =
      currentBudget.body.type === "fixed" ? currentBudget.body.amount : null;
    const plannedAmounts =
      currentBudget.body.type === "planned"
        ? currentBudget.body.planned_amounts
        : null;
    const filterTree =
      currentBudget.basedOn === "filterTree"
        ? currentBudget.body.filter_tree
        : null;
    const viewId =
      currentBudget.basedOn === "viewId" ? currentBudget.body.view_id : null;

    try {
      await dispatch(
        postUsersMeOrganisationsCurrentBudgets.initiate({
          body: {
            ...currentBudget.body,
            filter_tree: filterTree,
            view_id: viewId,
            start_date: formatDate(currentBudget.body.start_date, {
              type: "yearMonthDay",
            }),
            end_date: endDate
              ? formatDate(endDate, {
                  type: "yearMonthDay",
                })
              : null,
            thresholds: formatThresholds(currentBudget.body.thresholds),
            amount,
            planned_amounts: plannedAmounts,
          },
        }),
      ).unwrap();

      enqueueSnackbar(`${currentBudget.body.name} Budget created!`, {
        variant: "snackbarAlert",
        AlertSnackBarProps: { severity: "success" },
      });

      return "success";
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
      return "error";
    }
  },
);
